import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
});

export const enviarRegistro = (formData) => {
  return api.post("/registro", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const obtenerEvidencias = () => api.get("/evidencias");
